// Schema for Photography / Videography vendor-type-specific fields.

import { PHOTO_STYLES, PHOTO_SERVICES, PHOTO_ITEMS } from '../constants/vendorOptions';
import { rentalItemsGroupFields } from './fragments/rentalItemsGroup';

export const photographySchema = {
  vendorType: 'Photography',
  fields: [
    { key: 'photoVideoSpec', type: 'chips', label: 'Specializes In *', displayLabel: 'Specializes In', options: ['Photography', 'Videography'] },
    {
      type: 'row',
      fields: [
        { key: 'photoStartingPrice', type: 'price', label: 'Starting Price', optional: true },
        { key: 'photoAvgPrice', type: 'price', label: 'Average Price', optional: true },
      ],
    },
    { key: 'photoStyles', type: 'chips', label: 'Style', options: PHOTO_STYLES, optional: true },
    { key: 'photoServices', type: 'chips', label: 'Services', options: PHOTO_SERVICES, optional: true },
    { key: 'photoItems', type: 'chips', label: 'Items Offered', options: PHOTO_ITEMS, optional: true },
    { key: 'photoVideoOffersOtherItems', type: 'checkbox', label: 'We offer rental items', displayLabel: 'Rental Items' },
    ...rentalItemsGroupFields('photoVideoOffersOtherItems'),
  ],
  requiredChips: [
    { key: 'photoVideoSpec', label: 'specialization' },
  ],
  priceValidations: [
    { startingKey: 'photoStartingPrice', avgKey: 'photoAvgPrice' },
  ],
};